import contentMeta from '@/generated/content-meta.json'

export const CONTENT_VERSION = contentMeta.contentVersion
export const KNOWLEDGE_COUNT = contentMeta.knowledgeCount
export const QUESTION_COUNT = contentMeta.questionCount
